import Swiper from "swiper";
import { Navigation, Scrollbar, Autoplay, EffectFade } from "swiper/modules";

let mvSwiper = new Swiper(".mvSwiper", {
    autoplay: {
        delay: 5000,
    },
    speed: 4500,
    loop: true,
    effect: "fade",
    fadeEffect: {
        crossFade: true,
    },
    modules: [Autoplay, EffectFade],
});

let interSwiper = new Swiper(".InterSwiper", {
    modules: [Navigation, Scrollbar],
    slidesPerView: "auto",
    scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
        dragSize:
            innerWidth > 1024
                ? (288 / 1728) * innerWidth
                : (171 / 342) * innerWidth,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    on: {
        // slideChangeTransitionEnd: (swiper) => {
        //     swiper.update();
        // },
    },
});

// console.log(interSwiper);

// setInterval(() => {
//     interSwiper.forEach((swiper) => {
//         swiper.update();
//     });
// }, 100);

{
    /* <div class="swiper mySwiper">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <figure>
                    <img src="" alt="" />
                </figure>
            </div>
        </div>
    </div> */
    // @import '../../node_modules/swiper/swiper-bundle.min.css';
}
